import * as React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Category } from './category';
import { IRubric } from '../../reducers/modules/rubrics_menu/rubrics_menu';
import { IUser } from '../../types/user';
import { TDeviceType } from "@cian/ui-kit";
import { removeSlashes } from '../../../app/utils';
import cn from 'classnames';

import s from './nav_list_item.css';

export interface INavListItemProps {
  item: IRubric;
  activeNavItem: string;
  currentUser: IUser;
  deviceType: TDeviceType;
  onNavigationClick(): void;
}

export const NavListItem: React.FC<INavListItemProps> = props => {
  const location = useLocation();
  const { pathname } = location;

  const getSanitizedPath = (path: string) => {
    return path.slice(-1) === '/' ? path : `${path}/`;
  }

  function isDesktop() {
    return props.deviceType === 'desktop';
  }

  function isMobileOrTablet() {
    return props.deviceType === 'phone' || props.deviceType === 'tablet';
  }

  const isActive = () => {
    const { activeNavItem, item } = props;

    const pathnameWithoutSlashes = removeSlashes(pathname);
    const itemPathWithoutSlashed = removeSlashes(item.pathname);

    return activeNavItem === item.name && pathnameWithoutSlashes.startsWith(itemPathWithoutSlashed);
  }

  const showCategory = (path: string) => {
    const pathWithoutSlashes = removeSlashes(path);

    return pathname.includes(pathWithoutSlashes) ||
      (pathname.includes('/add-blog') && pathWithoutSlashes === 'blogs') ||
      (pathname.includes('/moi-blog') && pathWithoutSlashes === 'blogs') ||
      (pathname.includes('/add-vopros') && pathWithoutSlashes === 'forum-rieltorov');
  }

  const { activeNavItem, currentUser, item, onNavigationClick } = props;

  return (
    <li
      key={`navItem-${item.id}`}
      className={`
        ${s['navigation__item']}
        ${isActive() ? s['navigation__item_active'] : ''}
      `}
    >
      <Link
        className={cn(s['navigation__link'], {[s['navigation__link_highlighted']]: item.id === 26})}
        to={{ pathname: `${getSanitizedPath(item.pathname)}` }}
        onClick={onNavigationClick}
      >
        { item.name }
      </Link>

      { isDesktop() &&
        <div className={s.dekstop}>
          { showCategory(item.pathname)
            ? <Category
                currentUser={currentUser}
                categories={item.categories}
                pathname={item.pathname}
                activeNavItem={activeNavItem}
                onNavigationClick={onNavigationClick}
                routePath={pathname}
              />
            : null
          }
        </div>
      }
      { isMobileOrTablet() &&
        <div className={s.mobile}>
          <Category
            currentUser={currentUser}
            categories={item.categories}
            pathname={item.pathname}
            activeNavItem={activeNavItem}
            onNavigationClick={onNavigationClick}
            routePath={pathname}
          />
        </div>
      }
    </li>
  );
}
